import styled from '@emotion/styled';
import { Image } from '@neo-one/react-common';

export const AssetImage = styled(Image)`
  min-width: 0;
  min-height: 0;
  object-fit: scale-down;
  max-width: 100%;
`;
